module.exports = __webpack_public_path__ + "img/openai-account-banned-for-policy-violations.dcc13981.jpg";